import React, { useEffect, useState } from 'react';
import { equals, pick } from 'ramda';

import * as helpers from '../../helpers';
import * as actions from '../../store/actions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../../store';

export const FormRulesSpy: React.FC<{
    active: string | undefined;
    values: Record<string, any>;
}> = ({ active, values }) => {
    const dispatch = useDynamicReducerDispatch();
    const { fields, hiddenByRulesFields, rules } = useDynamicReducerSelector(pick(['fields', 'hiddenByRulesFields', 'rules']));
    const [storedActive, setStoredActive] = useState<string | undefined>();

    useEffect(() => {
        if (!fields.length || !rules.length) {
            return;
        }

        const hiddenFields = helpers.getHiddenByRulesFields({ rules, values });
        const updatedField = fields.find(field => field.name === storedActive);

        // toggle rules fields immediately after change
        const isNotTextFieldUpdated = storedActive === active && updatedField?.baseType !== 'text';
        // toggle rules fields after blur
        const isTextFieldBlurred = updatedField?.baseType === 'text' && !active;

        if (!equals(hiddenByRulesFields, hiddenFields) && (isTextFieldBlurred || isNotTextFieldUpdated)) {
            dispatch(actions.setHiddenByRulesFields(hiddenFields));
        }

        setStoredActive(active);
    }, [
        active,
        dispatch,
        fields,
        hiddenByRulesFields,
        rules,
        storedActive,
        values
    ]);

    return null;
};
